import script from "./labels.vue?vue&type=script&lang=js"
export * from "./labels.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/i18n/de/labels.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a3f98b5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a3f98b5', __exports__)) {
    api.reload('1a3f98b5', __exports__)
  }
  
}


export default __exports__